import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image19 from "../../../../assets/images/Blog43/image19 margin debt in investment huge.jpeg";
import image7 from "../../../../assets/images/Blog43/image7.jpeg";
import image6 from "../../../../assets/images/Blog43/image6 keep an eye on freight for recession (1).jpeg";
import image10 from "../../../../assets/images/Blog43/image10 mag7 chart.png";
import image38 from "../../../../assets/images/Blog43/image38.png";
import image24 from "../../../../assets/images/Blog43/image24 trouble in cds paradise  (1).png";
import image9 from "../../../../assets/images/Blog43/image9 power not chips is the risk.jpeg";
import image1 from "../../../../assets/images/Blog43/image1 EM set to benefit in the next upleg.jpeg";
import image3 from "../../../../assets/images/Blog43/image3 UJ nears pivot zone on stimulus.png";
import image12 from "../../../../assets/images/Blog43/image12 S&P record 50dam hold.png";
import image11 from "../../../../assets/images/Blog43/image11 sentiment complacent_ (1).png";
import image21 from "../../../../assets/images/Blog43/image21 NVDA GOOGL and APPL dominate Q3.png";
import image13 from "../../../../assets/images/Blog43/image13 SPX eps growth.png";
import image28 from "../../../../assets/images/Blog43/image 28 dr Copper telling you PMI going up.png";
import image36 from "../../../../assets/images/Blog43/image36 gold levels.png";
import image31 from "../../../../assets/images/Blog43/image31 MSTR under pressure_.jpeg";
import image29 from "../../../../assets/images/Blog43/image29 technically BTC should be buy (1).png";
import image37 from "../../../../assets/images/Blog43/image37 oil outlooks holding pressure.png";
import image39 from "../../../../assets/images/Blog43/image39 keep an eye o consolidation patterns.jpeg";
import image34 from "../../../../assets/images/Blog43/image34 BB commods breakout.png";

const Blog43 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – November 17th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedBoldText ">Liquidity Cracks, Narrow Breadth, and a Market Stuck in Transition</p>
        <p>
          The U.S. government shutdown finally ended, but instead of relief-driven strength, markets delivered a confused, uneven tape. Liquidity tightened, breadth weakened, and crypto suffered heavy
          technical damage. Yet the long-term trend remains intact — this is not a breakdown, but a transition phase where fatigued markets wait for a catalyst.
        </p>
        <p>
          Investors are navigating a late-cycle environment defined by margin pressure, constrained liquidity, cautious policy signals, and slowing global impulse. The next major turning point now
          hinges on Nvidia’s earnings, the returning data cycle, and whether liquidity stabilises into December.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Relief Without Confidence</p>
              <p>
                The shutdown’s conclusion should have lifted markets — instead, equities slumped. Thursday saw sharp selling across technology and high-beta names, and Friday opened soft again before
                covering flows offered mild relief.
              </p>
              <p>
                The real shock came from the liquidity side:<br></br>The Treasury is rebuilding its General Account toward <span className="highlightedText">$1T,</span> draining reserves from the
                financial system just as traders hoped for fresh liquidity.
              </p>

              <p>
                The economic impact is severe. The CBO expects the six-week freeze to cut Q4 GDP by <span className="highlightedText">1.5 percentage points,</span> dragging expected growth into the{" "}
                <span className="highlightedText">1.0%–1.5%</span> range.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt="hit to GDP"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Freight softness amplified macro anxiety. With shipping indices weakening again, traders debated whether this signals an early recession impulse or simply tariff noise.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="keep an eye on freight for recession"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Meanwhile, mega-cap concentration deepened. The S&P 500’s reliance on its largest names remains historically high — making the tape more sensitive to downside shocks.</p>
              <p>Liquidity can also be seen unwinding through rising margin debt and stress in higher-leverage segments.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt="margin debt in investment huge"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="mag7 chart"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The message from price action is simple:<br></br>
                <span className="highlightedText"> Relief is not conviction — markets want proof before committing.</span>
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: A Fragmented Fed and Slowing Global Liquidity</p>

              <p>Fed communication turned sharply mixed last week.</p>

              <p>
                Logan resisted further cuts.<br></br>
                Schmid warned against over-easing.<br></br>
                Musalem leaned defensive.<br></br>
                Daly flagged downside risks in the labor market.
              </p>

              <p>
                The result? <br></br>
                Markets have dramatically repriced December expectations — odds now sit well below 50%.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image38}
                    alt=" Dec cut less than"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image38)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Globally, the liquidity impulse is fading. The past year delivered <span className="highlightedText">167 rate cuts,</span> but only <span className="highlightedText">81</span> are
                expected in the next 12 months. This slowdown is showing up in crypto, credit spreads, and risk-asset sensitivity.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt="trouble in cds paradise"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Energy capacity emerged as the real bottleneck in AI scaling, not chips. China’s aggressive push in nuclear and renewables contrasts with U.S. affordability politics — a divergence
                that will shape 2026 sector dynamics.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="power not chips is the risk"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Emerging markets continue to show improving deal flow, led by Asia’s tech ecosystem and supportive capital environments.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="EM set to benefit in the next upleg"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>And with Japan’s fiscal expansion amplifying inflationary dynamics, the yen continued to hover near critical pivot levels — a key variable for global carry trades.</p>
              <div className="relatedImg">
                <img
                  src={image3}
                  alt="UJ nears pivot zone on stimulus"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image3)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
            <hr className="divisionLine" />
            <div className="subHeader">
              <div className="contentDivWrapper flexDiv">
                <div className="contentDiv listOfRecap">
                  <p className="highlightedBoldText">Technical & Sentiment Breakdown: A Correction Inside a Larger Uptrend</p>
                  <p>Breadth deterioration continued across indices:</p>
                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        Only <span className="highlightedText">32%–42%</span> of SPX & Nasdaq components sit above short-term moving averages
                      </p>
                    </li>
                    <li className="themesPointer">
                      <p> New lows dominate the 5-day and 1-month windows</p>
                    </li>
                    <li className="themesPointer">
                      <p>Correlations are rising</p>
                    </li>
                    <li className="themesPointer">
                      <p> Tech leadership is weakening</p>
                    </li>
                  </ul>
                  <p>
                    And yet — the bigger trend remains intact.<br></br>
                    The S&P 500 has now held above its <span className="highlightedText">50DMA for 198 consecutive days,</span> one of the longest streaks since 1950.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image12}
                        alt="S&P record 50dam hold"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image12)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <p>Sentiment has shifted from bullish to structurally complacent — the kind of mood that precedes volatility spikes.</p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image11}
                        alt="sentiment complacent?"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image11)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <p>
                    Breadth remains fragile. <br></br>
                    When only a narrow group is holding up the index, downside moves accelerate quickly. The Russell 1000 and equal-weight indices reflect deeper underlying weakness.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image21}
                        alt="NVDA GOOGL and APPL dominate"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image21)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <p>
                    Earnings, however, remain strong.<br></br>
                    Q3 has produced an <span className="highlightedText">82% beat rate,</span> the strongest since 2021 — an important counterweight to technical weakness.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image13}
                        alt="SPX eps growth"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image13)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <p>Credit spreads also reinforce caution. They continue to widen at the margin — not aggressively, but persistently.</p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image24}
                        alt="trouble in cds paradise"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image24)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <p>
                    The takeaway:<br></br>
                    <span className="highlightedText">This is a correction driven by positioning and liquidity, not fundamentals.</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Shutdown Ripples, Tech Anxiety, and Crypto Stress</p>
              <p>
                Markets opened weak but recovered into Friday as end-of-week covering, improving sentiment pockets, and strong earnings offered support — despite liquidity cracks and risk-off momentum
                earlier in the week.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>The shutdown ended, but the liquidity drain continued. Treasury’s TGA rebuild is absorbing system cash, tightening conditions. The GDP hit could be{" "}
                    <span className="highlightedText">1.5 percentage points</span> in Q4.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image7}
                        alt=" shutdown 1.5% hit to GDP"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image7)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China & Global:</span>
                    <br></br>Freight data softened again, raising questions about whether global demand is slowing or merely distorted by trade policy shifts.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image6}
                        alt="keep an eye on freight for recession"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image6)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br>Q3 earnings held up markets. <span className="highlightedText">82%</span> of S&P companies beat estimates — the highest since 2021. Healthcare, materials, and staples led
                    the upside.
                  </p>
                  <p>Additional earnings insights noted high investor concentration in mega-caps, amplifying reaction risk into NVDA’s print.</p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image21}
                        alt="NVDA GOOGL and APPL dominate Q3"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image21)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                    <div className="relatedImg">
                      <img
                        src={image13}
                        alt="SPX eps growth"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image13)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>

              <p className="highlightedText">Commodities:</p>
              <p>
                Gold saw a margin-driven dip but held long-term support. Silver’s volatility mirrored liquidity pressures. Copper’s strength hints at PMI improvement ahead — a bright macro signal.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image28}
                    alt="dr Copper telling you PMI going up"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image28)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image36}
                    alt="gold level"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image36)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p className="highlightedText">Crypto:</p>
              <p>BTC broke below the 200DMA and $100k amidst halving anxiety and ETF outflows. Structural Wave ((4)) correction remains intact.</p>
              <p>Ethereum slipped toward key supports near 3100.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image31}
                    alt="MSTR under pressure?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image31)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image29}
                    alt="technically BTC should be buy"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image29)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                <span className="highlightedText">Oil:</span>
                <br></br>
                WTI struggled at its 50DMA amid inventory builds and conservative demand forecasts.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image37}
                    alt="oil outlooks holding pressure"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image37)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Data Returns and NVDA Takes the Spotlight</p>
              <p>With the government reopened, markets will finally resume a full macro data cycle. The week is dense, and NVDA sits at the centre of global risk appetite.</p>
              <p className="highlightedText">Monday, Nov 17</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Fed Speakers: Williams, Jefferson, Kashkari, Logan, Waller</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Budget Statement</p>
                </li>
                <li className="themesPointer">
                  <p>EU Economic Forecasts</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Nov 18</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>ADP Employment</p>
                </li>
                <li className="themesPointer">
                  <p>NAHB Housing Index</p>
                </li>
                <li className="themesPointer">
                  <p> Industrial Production</p>
                </li>
                <li className="themesPointer">
                  <p>API Oil Stock</p>
                </li>
                <li className="themesPointer">
                  <p>RBA Minutes</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, Nov 19</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.K. CPI</p>
                </li>
                <li className="themesPointer">
                  <p> Eurozone CPI Final</p>
                </li>
                <li className="themesPointer">
                  <p>U.S. Mortgage Apps</p>
                </li>{" "}
                <li className="themesPointer">
                  <p>Building Permits</p>
                </li>
                <li className="themesPointer">
                  <p>EIA Inventories</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">FOMC Minutes</p>
                </li>
                <li className="themesPointer">
                  <p>Fed: Barkin, Williams</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">Earnings: NVIDIA (after hours)</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, Nov 20</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>U.S. Existing Home Sales</p>
                </li>
                <li className="themesPointer">
                  <p>Philadelphia Fed Index</p>
                </li>
                <li className="themesPointer">
                  <p>EU/Spain/Germany PPI & Trade</p>
                </li>
                <li className="themesPointer">
                  <p> China Loan Prime Rate</p>
                </li>
                <li className="themesPointer">
                  <p>Fed: Goolsbee, Dhingra</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, Nov 21</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p> Flash PMIs (U.S., EU, Japan, India)</p>
                </li>
                <li className="themesPointer">
                  <p>Real Earnings</p>
                </li>
                <li className="themesPointer">
                  <p>Michigan Sentiment</p>
                </li>
                <li className="themesPointer">
                  <p>Fed Speakers: Williams, Logan, Jefferson</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image38}
                    alt="Dec cut less than 50%"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image38)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image39}
                    alt="keep an eye on consolidation patterns"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image39)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: A Market in Transition — Not a Breakdown</p>
              <p>
                Liquidity is tight, breadth is weak, crypto is volatile — yet recession is not the base case, and long-term equity structure remains intact. This is a corrective phase inside a broader
                uptrend, not an end-of-cycle top.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>Expect choppy upside attempts until breadth improves. NVDA’s report is the single biggest catalyst of the week. A strong beat could restore leadership and stabilize semis.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>Gold remains structurally bullish despite margin-driven softness. Silver continues to behave like a leveraged
                    liquidity proxy — volatile but constructive.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>BTC weakness is liquidity-driven. Wave ((4)) structure remains the base case. Institutional inflows on dips remain the
                    most important bullish divergence.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br>December cut odds have collapsed. Shutdown distortions may produce noisy data. But with the Fed debating cuts — not hikes
                    — the macro regime still favors <span className="highlightedText">rotation,</span> not <span className="highlightedText">recession.</span>
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="sentiment complacent?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image34}
                    alt="BB commods breakout"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image34)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image29}
                    alt=" technically BTC should be buy"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image29)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The market is waiting for a catalyst, not collapsing.<br></br>
                <span className="highlightedText">Stay selective, stay patient, and let breadth confirm the turn.</span>
              </p>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1r5W1epAHm9b7AjJ48p0ksFmkcti9wmpZRfljBpzgvjU/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog43;
